export default [
    {
        path: 'exportApp',
        name: 'exportApp',
        component: (resolve) => require(['@/views/exportApp'], resolve),//app下载页
        meta:{
            title:''
        }
    },  
    {
        path: 'activity',
        name: 'activity',
        component: (resolve) => require(['@/views/activity/activeIndex'], resolve),//活动页面
        meta:{
            title:''
        }
    },  
    {
        path: 'activity/rules',
        name: 'activity_rules',
        component: (resolve) => require(['@/views/activity/activityRules'], resolve),//活动页面
        meta:{
            title:''
        }
    },  
    {
        path: 'activity/test',
        name: 'activity_test',
        component: (resolve) => require(['@/views/activity/test'], resolve),//活动页面
        meta:{
            title:''
        }
    },
    {
        path: 'activityInvoice',
        name: 'activity_invoice',
        component: (resolve) => require(['@/views/activity/invoice'], resolve),//学员发票
        meta:{
            title:''
        }
    },
    {
        path: 'like',
        name: 'like',
        component: (resolve) => require(['@/views/like/index'], resolve),//点赞页面
        meta:{
            title:''
        }
    },    
    {
        path: 'common',
        name: 'common',
        component: (resolve) => require(['@/views/common/index'], resolve),//普通页面
        meta:{
            title:''
        }
    },    
    {
        path: 'orderRules',
        name: 'orderRules',
        component: (resolve) => require(['@/views/agreement/orderRules'], resolve),//订单协议
        meta:{
            title:''
        }
    },   
    {
        path: 'userRules',
        name: 'userRules',
        component: (resolve) => require(['@/views/agreement/userRules'], resolve),//用户协议
        meta:{
            title:''
        }
    },  
    {
        path: 'userRulesCustom',
        name: 'userRulesCustom',
        component: (resolve) => require(['@/views/agreement/userRulesCustom'], resolve),//用户协议
        meta:{
            title:''
        }
    },  
    {
        path: 'privacyRules',
        name: 'privacyRules',
        component: (resolve) => require(['@/views/agreement/privacyRules'], resolve),//隐私政策
        meta:{
            title:''
        }
    },  
    {
        path: 'privacyRulesCustom',
        name: 'privacyRulesCustom',
        component: (resolve) => require(['@/views/agreement/privacyRulesCustom'], resolve),//隐私政策
        meta:{
            title:''
        }
    },  
    {
        path: 'appShare',
        name: 'appShare',
        component: (resolve) => require(['@/views/appShare/index'], resolve),//app分享
        meta:{
            title:''
        }
    },      
    {
        path: 'courseNotice',
        name: 'courseNotice',
        component: (resolve) => require(['@/views/courseNotice/index'], resolve),//课程通知
        meta:{
            title:''
        }
    },    
    {
        path: 'articleOuter',
        name: 'articleOuter',
        component: (resolve) => require(['@/views/articleOuter/index'], resolve),//外部文章
        meta:{
            title:''
        }
    },     
    {
        path: 'article',
        name: 'article',
        component: (resolve) => require(['@/views/article/index'], resolve),//文章
        meta:{
            title:''
        }
    },    
    {
        path: 'articleComment',
        name: 'articleComment',
        component: (resolve) => require(['@/views/articleComment/index'], resolve),//文章评论
        meta:{
            title:''
        }
    },   
    {
        path: 'questionDetail',
        name: 'questionDetail',
        component: (resolve) => require(['@/views/questionDetail/index'], resolve),//提问详情
        meta:{
            title:''
        }
    },          
    {
        path: 'questionCommentDetail',
        name: 'questionCommentDetail',
        component: (resolve) => require(['@/views/questionCommentDetail/index'], resolve),//提问评论详情
        meta:{
            title:''
        }
    },           
    {
        path: 'collectPersonalList',
        name: 'collectPersonalList',
        component: (resolve) => require(['@/views/collectPersonalList/index'], resolve),//个人信息收集清单-首页
        meta:{
            title:''
        }
    },  {
        path: 'collectPersonalListDetail',
        name: 'collectPersonalListDetail',
        component: (resolve) => require(['@/views/collectPersonalList/detail'], resolve),//个人信息收集清单-详情页
        meta:{
            title:''
        }
    },         
]


// WEBPACK FOOTER //
// ./src/router/home.js